export function isPeekdataError(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    return 'code' in error && 'message' in error && 'response' in error;
}
